export default __webpack_public_path__ + "static/media/social_icon_yokara.3ff68f51.jpg";